import React, { useState } from "react";
import dynamic from "next/dynamic";
import { getAssets } from "@unisearch/helpers";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });
import styles from "./instruction_gallery_card.module.scss";
import PlayButton from "@modules/study/common/play_btn";
import { Backdrop, Button, Modal } from "@mui/material";
import { FiX } from "react-icons/fi";

const InstructionGalleryCard = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <>
      <div className={styles.gallery_card}>
        <img
          className={styles.gallery_image}
          src={getAssets("assets/images/instruction_gallery2.png")}
          alt="Gallery"
        />
        <p className={styles.card_title}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Habitant.
        </p>
        <PlayButton onClick={() => setOpen(true)} />
        <div className={styles.overlay}></div>
      </div>

      <Modal
        open={isOpen}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div>
          <ModalVideo
            channel="custom"
            autoplay
            isOpen={isOpen}
            url="https://d2ogu7kfbtzzv3.cloudfront.net/files/UniSearch_Finale-1634995602483.mp4"
            onClose={() => setOpen(false)}
          />
        </div>
      </Modal>
    </>
  );
};
export default InstructionGalleryCard;
